import React from 'react';
import UserProfilePicture from './UserProfilePicture';
interface IProps {
    profileImage: string;
}

export default function UserPostPicture({ profileImage }: IProps) {
    return <UserProfilePicture profileImage={profileImage} />;
}
